import { reviewSm2, type Sm2Card } from "../review/sm2.ts";
import type { LearningResult } from "./types.ts";

const DAY = 86_400_000;

/** Study and repair are useful events, but neither extends a retention interval. */
export function scheduleLearning(
  card: Sm2Card & { lastRetrievedAt?: number },
  result: LearningResult,
  now = Date.now()
): Sm2Card {
  if (result === "independent")
    return card.lastRetrievedAt && now - card.lastRetrievedAt < 20 * 60 * 60 * 1000
      ? card
      : reviewSm2(card, 5, now);
  if (result === "missed" || result === "repaired") return reviewSm2(card, 1, now);
  if (result === "cued") {
    return {
      ...card,
      n: 0,
      box: Math.min(2, card.box),
      lastGrade: 3,
      reps: card.reps + 1,
      interval: 1,
      due: now + DAY,
    };
  }
  return card.reps === 0 ? { ...card, interval: 1, due: now + DAY } : card;
}
